import React /*, { useState, useEffect }*/ from "react";

import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faComment } from "@fortawesome/free-solid-svg-icons";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";

import { faFacebookSquare } from "@fortawesome/free-brands-svg-icons";
import { faInstagramSquare } from "@fortawesome/free-brands-svg-icons";
import { faTwitterSquare } from "@fortawesome/free-brands-svg-icons";

//import axios from "axios";

import "./contact.scss";

// import {
//   validateNameInput
//   , validateEmailInput
//   , validateMessageInput
//   , handleFormSubmit
// } from './contact-fn';

// const Messages = {
//   ErrorNameBlank: 'Name cannot be blank',
//   ErrorEmailFormat: 'Email is invalid or blank',
//   ErrorMessageBlank: 'Message cannot be blank',
//   ErrorMailApi: 'There was a problem sending your message, please try again later.',
//   ThankYou: 'Thank you for supporting local music! We\'ll be in touch soon',
// }

// constructor(props) {
//   super(props);
//   this.state = {
//     name: '',
//     nameIsValid: true,
//     nameErrorMessage: 'Name cannot be blank',
//     email: '',
//     emailIsValid: true,
//     emailBlankErrorMessage: 'Email cannot be blank',
//     emailInvalidErrorMessage: 'Email is invalid',
//     emailErrorMessage: 'Email cannot be blank',
//     message: '',
//     messageIsValid: true,
//     messageErrorMessage: 'Message cannot be blank',
//     thankYouMessage: 'Thank you for supporting local music! We\'ll be in touch soon',
//     mailSent: false,
//     mailSending: false,
//     mailSendingMessage: 'Sending...',
//     mailApiError: false,
//     mailApiErrorMessage: 'There was a problem sending your message, please try again later.',
//     mailserverUrl: 'https://we-salty-three-services.azurewebsites.net/api/email', // production
//     //mailserverUrl: 'https://localhost:44399/api/email', // development
//     error: null
//   }
// }

library.add(faComment);
library.add(faEnvelope);

function Contact() {
  // const [nameText, setNameText] = useState('');
  // const [email, setEmail] = useState('');
  // const [message, setMessage] = useState('');
  // const [nameIsValid, setNameIsValid] = useState(true);
  // const [emailIsValid, setEmailIsValid] = useState(true);
  // const [messageIsValid, setMessageIsValid] = useState(true);
  // const [mailSent, setMailSent] = useState(false);
  // const [mailSending, setMailSending] = useState(false);
  // const [mailApiError, setMailApiError] = useState(false);

  // useEffect(() => {
  //   window.document.getElementById("name-textbox")?.focus();
  //   return () => {
  //   };
  // }, []);

  return (
    <div className="contact-page">
      <div className="page-content gutter">
        <h1>Get Salty</h1>
        <div className="row title-row">
          <FontAwesomeIcon className="page-icon" icon={faComment} />
          <div className="page-copy">
            <p>
              Book us to play your event or venue. We show up on time and in
              tune. Give your audience an evening to remember #getsalty
            </p>
          </div>
        </div>
        <div className="row general-list event-types">
          <div>Birthday Parties</div>
          <div>Pub Events</div>
          <div>Wedding Receptions</div>
          <div>Life Milestones</div>
          <div>Corporate Events</div>
        </div>
        <div className="row media-links">
          <div>
            <a
              href="https://m.me/wesaltythree"
              className="fb-msg-btn"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon className="fa-10x" icon={faFacebookSquare} />
              Click here to message us on Facebook
            </a>
          </div>
          <div>
            <a
              href="https://ig.me/m/wesaltythree"
              className="ig-msg-btn"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon className="fa-10x" icon={faInstagramSquare} />
              Click here to message us on Instagram
            </a>
          </div>
          <div>
            <a href="https://twitter.com/messages/compose?recipient_id=1074506122021634048"
              className="twitter-dm-button" 
              data-screen-name="@wesaltythree"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon className="fa-10x" icon={faTwitterSquare} />
              Click here to message us on Twitter          
            </a>
          </div>
        </div>
        {/* 
        <div className="row">
          {mailSent === false && mailApiError === false && mailSending === false &&
            <div className="contact-form">
              <form>
                <div className="field">
                  <label>Name:</label>
                  <input id="name-textbox" type="textbox" tabIndex={1}
                    onChange={e => setNameText(e.target.value)}
                    onBlur={e => validateNameInput(nameText, setNameIsValid)}
                  />
                </div>
                <div className="error-text">
                  {Messages.ErrorNameBlank}
                </div>
                <div className="field">
                  <label>Email:</label>
                  <input id="email-textbox" type="email" tabIndex={2}
                    onChange={e => setEmail(e.target.value)}
                    onBlur={e => validateEmailInput(email, setEmailIsValid)}
                  />
                </div>
                <div className="error-text">
                  {Messages.ErrorEmailFormat}
                </div>
                <div className="field">
                  <label>Message:</label>
                  <textarea id="message-textarea" tabIndex={3}
                    onChange={e => setMessage(e.target.value)}
                    onBlur={e => validateMessageInput(message, setMessageIsValid)}
                  />
                </div>
                <div className="error-text">{Messages.ErrorMessageBlank}</div>
                <div className="submit-button-holder">
                  <button className="submit-button" type="submit" tabIndex={4}
                    onClick={e => handleFormSubmit(
                      e,
                      nameText,
                      email,
                      message,
                      nameIsValid,
                      emailIsValid,
                      messageIsValid,
                      mailSending, setMailSending,
                      setMailSent,
                      setMailApiError,
                    )}
                  >
                    Send
                  </button>
                </div>
              </form>
            </div>
          }

          {mailSending &&
            <div className="response-message">
              <FontAwesomeIcon className="page-icon" icon={faEnvelope} />
            </div>
          }
          {mailSent &&
            <div className="response-message">{Messages.ThankYou}</div>
          }
          {mailApiError &&
            <div className="response-message">{Messages.ErrorMailApi}</div>
          }
        </div> 
        */}
      </div>
    </div>
  );
}

export default Contact;
